// All Phases settings — default checklist template editor (Phelipe
// 2026-08-11). Plain form inputs named
// all_phases_config[checklist_template][] so the existing settings
// form submits them in row order; this controller only adds/removes
// rows and wires drag-reorder.

import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list", "row"]

  connect() {
    this._sortable = Sortable.create(this.listTarget, {
      handle: "[data-template-drag]",
      animation: 150
    })
  }

  disconnect() {
    if (this._sortable) {
      this._sortable.destroy()
      this._sortable = null
    }
  }

  addRow(event) {
    event?.preventDefault()
    const row = document.createElement("div")
    row.className = "flex items-center gap-1.5"
    row.setAttribute("data-checklist-template-target", "row")
    row.innerHTML = `
      <span data-template-drag class="px-0.5 text-gray-300 hover:text-gray-500 cursor-grab">
        <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor"><circle cx="2.5" cy="3" r="1.3"/><circle cx="7.5" cy="3" r="1.3"/><circle cx="2.5" cy="8" r="1.3"/><circle cx="7.5" cy="8" r="1.3"/><circle cx="2.5" cy="13" r="1.3"/><circle cx="7.5" cy="13" r="1.3"/></svg>
      </span>
      <input type="text" name="all_phases_config[checklist_template][]" value="" maxlength="160"
             class="flex-1 px-3 py-1.5 text-[13px] border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
      <button type="button" data-action="click->checklist-template#removeRow"
              class="w-5 h-5 shrink-0 text-gray-300 hover:text-red-600 cursor-pointer leading-none">×</button>
    `
    this.listTarget.appendChild(row)
    row.querySelector("input").focus()
  }

  removeRow(event) {
    event?.preventDefault()
    event.currentTarget.closest('[data-checklist-template-target="row"]')?.remove()
  }
}
